import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';
import { media } from '../../styles/breakpoints-2026';

const { colors } = tokens;

const SILHOUETTE_SCALE = '57%';
const BORDER_COLOUR = colors.neutral.background.default;

export const frame = css`
  aspect-ratio: 1;
  background-color: ${colors.neutral.subdued.default};
  border: 0;
  border-radius: 24px;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;

  ${media('<tablet')} {
    border-radius: 0;
  }

  ${media('>=tablet', '<desktop')} {
    border: 0;
  }

  ${media('>=desktop')} {
    border: 1px solid ${BORDER_COLOUR};
  }
`;

export const photo = css`
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const silhouetteFrame = css`
  align-items: center;
  display: flex;
  justify-content: center;

  ${media('>=desktop')} {
    border: 1px solid ${BORDER_COLOUR};
  }
`;

export const silhouette = css`
  color: ${colors.secondary.trim.hover};
  height: ${SILHOUETTE_SCALE};
  width: auto;
`;
